import { getObjectValueByPath } from "vuetify/lib/util/helpers";

export default function sortByKey( arr, key ) {
	const arrCopy = arr.slice();

	return arrCopy.sort( ( a, b ) => {
		const x = getObjectValueByPath( a, key );
		const y = getObjectValueByPath( b, key );

		return x.localeCompare( y );
	} );
}
